import { render } from "./UnarchiveCohortModal.vue?vue&type=template&id=8e85ae60"
import script from "./UnarchiveCohortModal.vue?vue&type=script&lang=js"
export * from "./UnarchiveCohortModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__